module.exports = "<div>\r\n  <label>Facilities</label>\r\n<ng-multiselect-dropdown\r\n  [settings]=\"dropdownSettings\"\r\n  [data]=\"dropdownList\"\r\n  [(ngModel)]=\"selectedItems\"\r\n  (ngModelChange)=\"emitByType($event)\"\r\n>\r\n</ng-multiselect-dropdown>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/multi-select-dropdown/facility-multi-select/facility-multi-select.component.html
// module id = 2342
// module chunks = 66